"use client";

import { useEffect, useState } from "react";
import { preloadWorkspaceAvatars } from "@/lib/workspaceImageCache";

type WorkspaceAvatarPreloadInput = {
    id?: string;
    imageUrl?: string | null;
    tags?: Array<{ key?: string; value?: string }> | null;
};

export function useWorkspaceAvatarsPreload(
    workspaces: WorkspaceAvatarPreloadInput[],
): boolean {
    const [ready, setReady] = useState(workspaces.length === 0);
    const workspaceKey = workspaces
        .map((workspace) => {
            const imageUrl = workspace.imageUrl ?? "";
            const tagsKey = (workspace.tags ?? [])
                .map((tag) => `${tag.key ?? ""}:${tag.value ?? ""}`)
                .join("|");
            return `${workspace.id ?? ""}:${imageUrl}:${tagsKey}`;
        })
        .join(";");

    useEffect(() => {
        if (workspaces.length === 0) {
            setReady(true);
            return;
        }

        let cancelled = false;
        setReady(false);

        void preloadWorkspaceAvatars(workspaces).finally(() => {
            if (!cancelled) setReady(true);
        });

        return () => {
            cancelled = true;
        };
    }, [workspaceKey]);

    return ready;
}
